import React from "react"

export const DashboardIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
        >
            <path
                d="M14.2222 18.5H4.77778C2.69137 18.5 1 16.6391 1 14.3436V7.80519C1 6.35177 1.69002 5.00394 2.81975 4.25063L7.54197 1.10186C8.74548 0.299381 10.2545 0.299381 11.458 1.10186L16.1802 4.25063C17.31 5.00394 18 6.35177 18 7.80519V14.3436C18 16.6391 16.3086 18.5 14.2222 18.5Z"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M6.66699 14.3438H12.3337"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    )
}

export const SetupIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="24"
            viewBox="0 0 22 24"
            fill="none"
        >
            <path
                d="M17.7668 6.66821C17.5706 6.3504 17.2484 6.11766 16.8709 6.02275C16.4925 5.92783 16.0903 5.97775 15.7517 6.16126C15.189 6.46568 14.5106 6.46533 13.9483 6.16035L13.3655 5.84433C12.838 5.55826 12.5095 5.00633 12.5095 4.40625C12.5095 3.64125 11.851 3 11.0367 3H8.9632C8.1489 3 7.49037 3.64125 7.49037 4.40625C7.49037 5.00637 7.16193 5.55836 6.63449 5.84464L6.05245 6.16057C5.49008 6.46581 4.81152 6.46607 4.24892 6.16126C3.91032 5.97775 3.50728 5.92782 3.12898 6.02275C2.75141 6.11767 2.4293 6.3504 2.23301 6.66821L1.19772 8.3529C1.0022 8.67071 0.948999 9.04899 1.05014 9.40336C1.15127 9.75845 1.39848 10.0608 1.73709 10.2443C2.29109 10.545 2.63616 11.1248 2.63635 11.7551L2.63649 12.2449C2.63668 12.8752 2.29179 13.455 1.73784 13.7557C1.39923 13.9399 1.15126 14.2416 1.05014 14.5959C0.949009 14.951 1.00219 15.3293 1.19772 15.6471L2.23451 17.3318C2.43002 17.6496 2.75215 17.8823 3.12973 17.9773C3.50805 18.0722 3.91032 18.0223 4.24967 17.8387C4.81235 17.5343 5.4907 17.5347 6.05306 17.8397L6.63371 18.1546C7.16159 18.4409 7.49036 18.9932 7.49036 19.5938C7.49036 20.3588 8.1488 21 8.9632 21H11.0361C11.8511 21 12.5089 20.3588 12.5089 19.5938C12.5093 18.9932 12.8384 18.441 13.3663 18.1547L13.9476 17.8396C14.51 17.5346 15.1884 17.5343 15.7511 17.8387C16.0904 18.0222 16.4927 18.0722 16.8703 17.9773C17.2486 17.8823 17.5707 17.6496 17.7662 17.3318L18.8023 15.6471C18.9978 15.3293 19.051 14.951 18.9499 14.5966C18.8487 14.2416 18.6015 13.9392 18.2629 13.7557C17.7089 13.455 17.364 12.8752 17.364 12.2449V11.7551C17.364 11.1248 17.7089 10.545 18.2629 10.2443C18.6015 10.0601 18.8487 9.75843 18.9499 9.40405C19.051 9.04896 18.9978 8.67069 18.8023 8.35288L17.7668 6.66821Z"
                stroke-linecap="round"
            />
            <path
                d="M13 12C13 13.6569 11.6569 15 10 15C8.3431 15 7 13.6569 7 12C7 10.3431 8.3431 9 10 9C11.6569 9 13 10.3431 13 12Z"
                stroke-linecap="round"
            />
        </svg>
    )
}

export const ReferralIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
        >
            <path
                d="M19 7.5H10M19 12.5H10M19 17.5H10M7 7.5C7 8.05228 6.55228 8.5 6 8.5C5.44772 8.5 5 8.05228 5 7.5C5 6.94772 5.44772 6.5 6 6.5C6.55228 6.5 7 6.94772 7 7.5ZM7 12.5C7 13.0523 6.55228 13.5 6 13.5C5.44772 13.5 5 13.0523 5 12.5C5 11.9477 5.44772 11.5 6 11.5C6.55228 11.5 7 11.9477 7 12.5ZM7 17.5C7 18.0523 6.55228 18.5 6 18.5C5.44772 18.5 5 18.0523 5 17.5C5 16.9477 5.44772 16.5 6 16.5C6.55228 16.5 7 16.9477 7 17.5Z"
                stroke-linecap="round"
            />
        </svg>
    )
}

export const ReferrerIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
        >
            <mask
                id="mask0_122_516"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="25"
                height="25"
            >
                <rect
                    x="0.179688"
                    y="0.234375"
                    width="24"
                    height="24"
                    fill="#D9D9D9"
                />
            </mask>
            <g mask="url(#mask0_122_516)">
                <path
                    d="M10.9547 13.2344C10.6732 13.2344 10.4419 13.1267 10.2607 12.9114C10.0797 12.6959 10.0117 12.4445 10.0567 12.1574L10.2604 10.8574C10.3424 10.3844 10.5678 9.99563 10.9364 9.69113C11.3049 9.38663 11.7209 9.23438 12.1842 9.23438C12.6582 9.23438 13.0794 9.38663 13.4479 9.69113C13.8166 9.99563 14.0419 10.3844 14.1239 10.8574L14.3277 12.1574C14.3727 12.4445 14.3047 12.6959 14.1237 12.9114C13.9425 13.1267 13.7112 13.2344 13.4297 13.2344H10.9547ZM11.0547 12.2344H13.3297L13.1297 11.0094C13.0964 10.776 12.988 10.5885 12.8047 10.4469C12.6214 10.3052 12.413 10.2344 12.1797 10.2344C11.9464 10.2344 11.7422 10.3052 11.5672 10.4469C11.3922 10.5885 11.288 10.776 11.2547 11.0094L11.0547 12.2344ZM3.93594 13.9209C3.66644 13.9375 3.43035 13.886 3.22769 13.7664C3.02502 13.6465 2.89302 13.4609 2.83169 13.2094C2.79835 13.0979 2.79319 12.9895 2.81619 12.8844C2.83935 12.7792 2.87144 12.677 2.91244 12.5779C2.91244 12.5904 2.9041 12.5656 2.88744 12.5036C2.86694 12.4703 2.80919 12.328 2.71419 12.0766C2.69369 11.928 2.71269 11.7901 2.77119 11.6631C2.82952 11.5363 2.90544 11.4267 2.99894 11.3344C3.01177 11.3344 3.02202 11.3241 3.02969 11.3036C3.05419 11.079 3.1491 10.8898 3.31444 10.7361C3.47977 10.5825 3.67777 10.5056 3.90844 10.5056C3.9201 10.5056 4.0336 10.5261 4.24894 10.5671L4.30469 10.5614C4.36235 10.4972 4.43735 10.4491 4.52969 10.4171C4.62202 10.385 4.7201 10.3689 4.82394 10.3689C4.95694 10.3689 5.07477 10.3885 5.17744 10.4276C5.28027 10.4668 5.36127 10.5335 5.42044 10.6276C5.43244 10.6276 5.44135 10.631 5.44719 10.6376C5.45319 10.6445 5.4621 10.6479 5.47394 10.6479C5.63027 10.6645 5.77269 10.7165 5.90119 10.8036C6.02952 10.891 6.12427 11.0102 6.18544 11.1614C6.20594 11.2524 6.21527 11.3328 6.21344 11.4026C6.21144 11.4725 6.19377 11.5445 6.16044 11.6189C6.16044 11.6227 6.16877 11.6496 6.18544 11.6996C6.27644 11.7908 6.34244 11.8815 6.38344 11.9719C6.4246 12.0622 6.44519 12.1632 6.44519 12.2749C6.44519 12.303 6.41435 12.4267 6.35269 12.6459C6.34885 12.6535 6.34885 12.6805 6.35269 12.7266C6.36552 12.7651 6.37577 12.86 6.38344 13.0114C6.38344 13.261 6.27877 13.475 6.06944 13.6534C5.8601 13.8317 5.60585 13.9209 5.30669 13.9209H3.93594ZM19.7074 14.0036C19.3184 14.0036 18.9826 13.8635 18.6999 13.5831C18.4173 13.3028 18.2759 12.9658 18.2759 12.5721C18.2759 12.429 18.2964 12.296 18.3374 12.1731C18.3786 12.0503 18.4344 11.9303 18.5047 11.8131L18.0032 11.3776C17.8837 11.2846 17.8627 11.167 17.9402 11.0246C18.0177 10.8825 18.128 10.8114 18.2712 10.8114H19.7027C20.0964 10.8114 20.4314 10.95 20.7077 11.2271C20.9839 11.5043 21.1219 11.8375 21.1219 12.2266V12.5806C21.1219 12.964 20.9834 13.297 20.7064 13.5796C20.4294 13.8623 20.0964 14.0036 19.7074 14.0036ZM1.17969 17.8114V16.9479C1.17969 16.3299 1.50602 15.8193 2.15869 15.4161C2.81135 15.013 3.65827 14.8114 4.69944 14.8114C4.8901 14.8114 5.0726 14.8187 5.24694 14.8334C5.42127 14.8482 5.58735 14.8723 5.74519 14.9056C5.60152 15.162 5.4906 15.4312 5.41244 15.7134C5.33427 15.9955 5.29519 16.2961 5.29519 16.6151V17.8114H1.17969ZM7.17969 17.8114V16.6864C7.17969 15.8594 7.64202 15.2023 8.56669 14.7151C9.49119 14.228 10.6973 13.9844 12.1849 13.9844C13.6866 13.9844 14.8944 14.228 15.8084 14.7151C16.7226 15.2023 17.1797 15.8594 17.1797 16.6864V17.8114H7.17969ZM19.6797 14.8114C20.7297 14.8114 21.5755 15.013 22.2172 15.4161C22.8589 15.8193 23.1797 16.3299 23.1797 16.9479V17.8114H19.0642V16.6151C19.0642 16.2961 19.0293 15.9955 18.9594 15.7134C18.8896 15.4312 18.7849 15.162 18.6452 14.9056C18.8029 14.8723 18.9691 14.8482 19.1439 14.8334C19.3188 14.8187 19.4974 14.8114 19.6797 14.8114ZM12.1774 14.9844C11.0494 14.9844 10.1137 15.135 9.37019 15.4364C8.62652 15.7375 8.23927 16.1254 8.20844 16.5999V16.8114H16.1567V16.5999C16.122 16.1254 15.737 15.7375 15.0017 15.4364C14.2665 15.135 13.3251 14.9844 12.1774 14.9844Z"
                    fill="white"
                />
            </g>
        </svg>
    )
}

export const BusinessIreferIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
        >
            <mask
                id="mask0_122_507"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="25"
            >
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    fill="#D9D9D9"
                />
            </mask>
            <g mask="url(#mask0_122_507)">
                <path
                    d="M2.73047 20.6533V3.65332H11.7305V7.65332H21.269V15.9611H20.269V8.65332H11.7305V11.6533H14.1152V12.6533H11.7305V15.6533H14.1152V16.6533H11.7305V19.6533H16.4997V20.6533H2.73047ZM3.73047 19.6533H6.73047V16.6533H3.73047V19.6533ZM3.73047 15.6533H6.73047V12.6533H3.73047V15.6533ZM3.73047 11.6533H6.73047V8.65332H3.73047V11.6533ZM3.73047 7.65332H6.73047V4.65332H3.73047V7.65332ZM7.73047 19.6533H10.7305V16.6533H7.73047V19.6533ZM7.73047 15.6533H10.7305V12.6533H7.73047V15.6533ZM7.73047 11.6533H10.7305V8.65332H7.73047V11.6533ZM7.73047 7.65332H10.7305V4.65332H7.73047V7.65332ZM20.269 22.6533V20.6533H18.269V19.6533H20.269V17.6533H21.269V19.6533H23.269V20.6533H21.269V22.6533H20.269ZM16.4997 12.6533V11.6533H17.4997V12.6533H16.4997ZM16.4997 16.6533V15.6533H17.4997V16.6533H16.4997Z"
                    fill="white"
                />
            </g>
        </svg>
    )
}

export const ReferReferUsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
        >
            <g clip-path="url(#clip0_122_605)">
                <path d="M2.19236 13.7184H6.65971e-07V8.16797C6.65971e-07 8.16797 -0.0172621 2.6547 5.50678 3.95412C7.8545 4.88228 8.07891 8.3536 8.07891 8.3536H5.81751C5.81751 8.3536 5.81751 6.07033 4.03946 6.05176C2.55487 6.14458 2.24414 7.42544 2.24414 8.33504C2.24414 9.24463 2.19236 13.7184 2.19236 13.7184Z" />
                <path d="M6.21484 4.02832H8.07921V6.55292C8.07921 6.55292 7.47502 4.88223 6.21484 4.02832Z" />
                <path d="M5.76577 9.61585C5.76577 9.61585 5.45504 13.8668 9.71891 13.9968C10.1657 14.0103 11.1923 14.0163 12.1894 13.291C12.333 13.1867 12.9881 12.6944 13.4649 11.7321C13.9362 10.7809 13.9465 9.93402 13.9483 8.27929C13.9505 6.02906 13.9491 4.67172 13.9483 4.02832H11.566V8.39067C11.566 8.39067 11.825 11.7506 9.4945 11.6021C7.99265 11.4165 8.07896 9.59728 8.07896 9.59728L5.76577 9.61585Z" />
                <path d="M2.08042 3.1557C2.86696 3.1557 3.50459 2.47004 3.50459 1.62424C3.50459 0.778434 2.86696 0.0927734 2.08042 0.0927734C1.29387 0.0927734 0.65625 0.778434 0.65625 1.62424C0.65625 2.47004 1.29387 3.1557 2.08042 3.1557Z" />
                <path d="M7.18979 3.06293C7.97634 3.06293 8.61396 2.37727 8.61396 1.53146C8.61396 0.68566 7.97634 0 7.18979 0C6.40325 0 5.76562 0.68566 5.76562 1.53146C5.76562 2.37727 6.40325 3.06293 7.18979 3.06293Z" />
                <path d="M12.5755 3.1557C13.3621 3.1557 13.9997 2.47004 13.9997 1.62424C13.9997 0.778434 13.3621 0.0927734 12.5755 0.0927734C11.789 0.0927734 11.1514 0.778434 11.1514 1.62424C11.1514 2.47004 11.789 3.1557 12.5755 3.1557Z" />
            </g>
            <defs>
                <clipPath id="clip0_122_605">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const InviteAReferrerIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="24"
            viewBox="0 0 21 24"
            fill="none"
        >
            <path
                d="M14.9997 18V15.5M14.9997 18V20.5M14.9997 18H12.4997M14.9997 18H17.4997M11.9997 14.1241C11.081 13.7227 10.0664 13.5 8.9997 13.5C5.5419 13.5 2.63061 15.84 1.76307 19.0229C1.4726 20.0886 2.39517 21 3.49974 21H9.9997M12.4997 7C12.4997 8.933 10.9327 10.5 8.9997 10.5C7.0667 10.5 5.49974 8.933 5.49974 7C5.49974 5.067 7.0667 3.5 8.9997 3.5C10.9327 3.5 12.4997 5.067 12.4997 7Z"
                stroke-width="1.25"
                stroke-linecap="round"
            />
        </svg>
    )
}

export const SocialMediaIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
        >
            <path
                d="M21.5 12.5C21.5 7.25329 17.2467 3 12 3C6.75329 3 2.5 7.25329 2.5 12.5C2.5 17.7467 6.75329 22 12 22C13.429 22 14.7843 21.6845 16 21.1194M21.5 12.75C21.5 13.9926 20.4926 15 19.25 15C18.0074 15 17 13.9926 17 12.75M17 12.5C17 15.2614 14.7614 17.5 12 17.5C9.23858 17.5 7 15.2614 7 12.5C7 9.73858 9.23858 7.5 12 7.5C14.7614 7.5 17 9.73858 17 12.5Z"
                stroke-width="1.25"
                stroke-linecap="round"
            />
        </svg>
    )
}

export const ReferUsNetworkIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
        >
            <mask
                id="mask0_265_2171"
                maskUnits="userSpaceOnUse"
                x="-3"
                y="-3"
                width="25"
                height="25"
            >
                <rect
                    x="-2.4873"
                    y="-2.88477"
                    width="24"
                    height="24"
                    fill="#D9D9D9"
                />
            </mask>
            <g mask="url(#mask0_265_2171)">
                <path
                    d="M2.98998 13.6378C2.06564 12.702 1.38323 11.677 0.942727 10.5628C0.502393 9.4488 0.282227 8.29946 0.282227 7.1148C0.282227 5.93013 0.502393 4.7808 0.942727 3.6668C1.38323 2.55263 2.06564 1.52763 2.98998 0.591797L3.65148 1.2533C2.82581 2.0918 2.21298 3.0158 1.81298 4.0253C1.41298 5.03496 1.21298 6.0648 1.21298 7.1148C1.21298 8.1648 1.41298 9.19463 1.81298 10.2043C2.21298 11.2138 2.82581 12.1378 3.65148 12.9763L2.98998 13.6378ZM5.31298 11.3148C4.73998 10.7161 4.30823 10.0533 4.01773 9.3263C3.72739 8.59946 3.58223 7.8623 3.58223 7.1148C3.58223 6.3673 3.72739 5.63013 4.01773 4.9033C4.30823 4.1763 4.73998 3.51346 5.31298 2.9148L5.97448 3.5763C5.48731 4.05196 5.12198 4.6013 4.87848 5.2243C4.63481 5.84746 4.51298 6.47763 4.51298 7.1148C4.51298 7.74046 4.63156 8.36163 4.86873 8.9783C5.10589 9.59496 5.47448 10.1533 5.97448 10.6533L5.31298 11.3148ZM5.58998 17.461L8.50348 8.72055C8.21114 8.55138 7.98581 8.31805 7.82748 8.02055C7.66914 7.72305 7.58998 7.42113 7.58998 7.1148C7.58998 6.58146 7.77714 6.12763 8.15148 5.7533C8.52581 5.37896 8.97964 5.1918 9.51298 5.1918C10.0463 5.1918 10.5001 5.37896 10.8745 5.7533C11.2488 6.12763 11.436 6.58146 11.436 7.1148C11.436 7.42113 11.3632 7.71663 11.2177 8.0013C11.0722 8.28596 10.8405 8.52571 10.5225 8.72055L13.436 17.461H12.3975L11.7475 15.461H7.28423L6.64748 17.461H5.58998ZM7.62648 14.461H11.3995L9.51298 8.76855L7.62648 14.461ZM13.713 11.3148L13.0515 10.6533C13.5386 10.1776 13.904 9.6283 14.1475 9.0053C14.3911 8.38213 14.513 7.75196 14.513 7.1148C14.513 6.52763 14.3911 5.9193 14.1475 5.2898C13.904 4.6603 13.5386 4.08913 13.0515 3.5763L13.713 2.9148C14.286 3.51346 14.7148 4.18271 14.9995 4.92255C15.2841 5.66221 15.4322 6.39938 15.4437 7.13405C15.4437 7.88155 15.3017 8.61555 15.0177 9.33605C14.7337 10.0565 14.2988 10.7161 13.713 11.3148ZM16.036 13.6378L15.3745 12.9763C16.2001 12.1378 16.813 11.2138 17.213 10.2043C17.613 9.19463 17.813 8.1648 17.813 7.1148C17.813 6.0648 17.613 5.03496 17.213 4.0253C16.813 3.0158 16.2001 2.0918 15.3745 1.2533L16.036 0.591797C16.9476 1.52763 17.6268 2.55263 18.0735 3.6668C18.5203 4.7808 18.7437 5.93013 18.7437 7.1148C18.7437 8.29946 18.5296 9.4488 18.1015 10.5628C17.6733 11.677 16.9848 12.702 16.036 13.6378Z"
                    fill="white"
                />
            </g>
        </svg>
    )
}

export const AccountIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="23"
            viewBox="0 0 21 23"
            fill="none"
        >
            <path
                d="M12.4705 2.39551H6.52884C4.38197 2.39551 3.30854 2.39551 2.48855 2.81331C1.76726 3.18083 1.18083 3.76726 0.813312 4.48855C0.395508 5.30854 0.395508 6.38197 0.395508 8.52884V14.4705C0.395508 16.6174 0.395508 17.6908 0.813312 18.5108C1.18083 19.2321 1.76726 19.8185 2.48855 20.186C3.30854 20.6038 4.38197 20.6038 6.52884 20.6038H12.4705C14.6174 20.6038 15.6908 20.6038 16.5108 20.186C17.2321 19.8185 17.8185 19.2321 18.186 18.5108C18.6038 17.6908 18.6038 16.6174 18.6038 14.4705V8.52884C18.6038 6.38197 18.6038 5.30854 18.186 4.48855C17.8185 3.76726 17.2321 3.18083 16.5108 2.81331C15.6908 2.39551 14.6174 2.39551 12.4705 2.39551Z"
                stroke-width="1.25"
                stroke-linecap="round"
            />
            <path
                d="M9.66767 13.417C7.51824 13.417 5.66932 14.3517 4.84901 15.8866C4.35009 16.8202 5.25496 17.7295 6.3135 17.7295H13.0218C14.0804 17.7295 14.9853 16.8202 14.4864 15.8866C13.666 14.3517 11.8171 13.417 9.66767 13.417Z"
                stroke-width="1.25"
                stroke-linecap="round"
            />
            <path
                d="M12.0641 8.14583C12.0641 9.46901 10.9915 10.5417 9.66829 10.5417C8.34512 10.5417 7.27246 9.46901 7.27246 8.14583C7.27246 6.82265 8.34512 5.75 9.66829 5.75C10.9915 5.75 12.0641 6.82265 12.0641 8.14583Z"
                stroke-width="1.25"
                stroke-linecap="round"
            />
        </svg>
    )
}

export const HelpIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
        >
            <path
                d="M21 12.5C21 17.4706 16.9706 21.5 12 21.5C7.02944 21.5 3 17.4706 3 12.5C3 7.52944 7.02944 3.5 12 3.5C16.9706 3.5 21 7.52944 21 12.5Z"
                stroke-width="1.25"
                stroke-linecap="round"
            />
            <path
                d="M11 12.5V16.5C11 17.0523 11.4477 17.5 12 17.5C12.5523 17.5 13 17.0523 13 16.5V12.5C13 11.9477 12.5523 11.5 12 11.5C11.4477 11.5 11 11.9477 11 12.5Z"
                stroke-width="1.25"
                stroke-linecap="round"
            />
            <path
                d="M13 8.5C13 7.94772 12.5523 7.5 12 7.5C11.4477 7.5 11 7.94772 11 8.5C11 9.05229 11.4477 9.5 12 9.5C12.5523 9.5 13 9.05229 13 8.5Z"
                stroke-width="1.25"
                stroke-linecap="round"
            />
        </svg>
    )
}

export const InstagramIcon =()=> {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M20.9796 6.17406C20.9304 5.05825 20.75 4.29114 20.4915 3.62643C20.2249 2.92085 19.8146 2.28915 19.2772 1.76402C18.752 1.23071 18.1162 0.816306 17.4188 0.553819C16.7502 0.295338 15.9871 0.114898 14.8713 0.0657019C13.7472 0.0123391 13.3903 0 10.5391 0C7.68801 0 7.33113 0.0123391 6.21116 0.0615355C5.09535 0.110732 4.32824 0.291332 3.66369 0.549653C2.95796 0.816306 2.32626 1.22654 1.80112 1.76402C1.26782 2.28915 0.853575 2.92502 0.590928 3.62242C0.332447 4.29114 0.152007 5.05408 0.102811 6.16989C0.0494485 7.29403 0.0371094 7.65091 0.0371094 10.5021C0.0371094 13.3532 0.0494485 13.7101 0.0986447 14.83C0.147841 15.9459 0.328441 16.713 0.586921 17.3777C0.853575 18.0833 1.26782 18.7149 1.80112 19.2401C2.32626 19.7734 2.96212 20.1878 3.65952 20.4503C4.32824 20.7088 5.09118 20.8892 6.20715 20.9384C7.32697 20.9878 7.684 20.9999 10.5351 20.9999C13.3863 20.9999 13.7431 20.9878 14.8631 20.9384C15.9789 20.8892 16.746 20.7088 17.4106 20.4503C18.8219 19.9046 19.9377 18.7888 20.4834 17.3777C20.7417 16.709 20.9223 15.9459 20.9715 14.83C21.0207 13.7101 21.033 13.3532 21.033 10.5021C21.033 7.65091 21.0288 7.29403 20.9796 6.17406ZM19.0886 14.748C19.0434 15.7736 18.8711 16.3274 18.7275 16.6966C18.3746 17.6115 17.6486 18.3376 16.7337 18.6904C16.3645 18.834 15.8067 19.0063 14.7851 19.0513C13.6774 19.1007 13.3453 19.1128 10.5433 19.1128C7.74137 19.1128 7.40501 19.1007 6.30138 19.0513C5.27579 19.0063 4.72197 18.834 4.35276 18.6904C3.89749 18.5222 3.48309 18.2555 3.14673 17.9068C2.79803 17.5663 2.53137 17.1561 2.36311 16.7008C2.21953 16.3316 2.04726 15.7736 2.00223 14.7522C1.95288 13.6445 1.9407 13.3122 1.9407 10.5102C1.9407 7.70828 1.95288 7.37192 2.00223 6.26844C2.04726 5.24285 2.21953 4.68903 2.36311 4.31982C2.53137 3.86439 2.79803 3.45015 3.15089 3.11363C3.49126 2.76493 3.9015 2.49828 4.35692 2.33017C4.72614 2.18659 5.28412 2.01432 6.30554 1.96913C7.41318 1.91994 7.74554 1.9076 10.5473 1.9076C13.3534 1.9076 13.6856 1.91994 14.7893 1.96913C15.8148 2.01432 16.3687 2.18659 16.7379 2.33017C17.1931 2.49828 17.6075 2.76493 17.9439 3.11363C18.2926 3.45416 18.5593 3.86439 18.7275 4.31982C18.8711 4.68903 19.0434 5.24686 19.0886 6.26844C19.1377 7.37608 19.1501 7.70828 19.1501 10.5102C19.1501 13.3122 19.1377 13.6404 19.0886 14.748Z" fill="#F47523" />
                                    <path d="M10.5391 5.10748C7.56092 5.10748 5.14453 7.52371 5.14453 10.5021C5.14453 13.4805 7.56092 15.8967 10.5391 15.8967C13.5175 15.8967 15.9337 13.4805 15.9337 10.5021C15.9337 7.52371 13.5175 5.10748 10.5391 5.10748ZM10.5391 14.0014C8.60702 14.0014 7.03979 12.4344 7.03979 10.5021C7.03979 8.56981 8.60702 7.00274 10.5391 7.00274C12.4714 7.00274 14.0385 8.56981 14.0385 10.5021C14.0385 12.4344 12.4714 14.0014 10.5391 14.0014V14.0014Z" fill="#F47523" />
                                    <path d="M17.4067 4.89413C17.4067 5.58961 16.8427 6.15353 16.1471 6.15353C15.4516 6.15353 14.8877 5.58961 14.8877 4.89413C14.8877 4.19849 15.4516 3.63474 16.1471 3.63474C16.8427 3.63474 17.4067 4.19849 17.4067 4.89413V4.89413Z" fill="#F47523" />
                                </svg>
    )
}

export const FacebookIcon =()=> {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none">
                                    <path d="M7.98017 21.4074V11.805H11.202L11.6854 8.06171H7.98017V5.67213C7.98017 4.58869 8.2798 3.85034 9.83522 3.85034L11.8158 3.84952V0.501355C11.4733 0.456845 10.2976 0.354797 8.92914 0.354797C6.07167 0.354797 4.11539 2.09897 4.11539 5.3014V8.06171H0.883789V11.805H4.11539V21.4074H7.98017Z" fill="#F47523" />
                                </svg>
    )
}

export const LinkedinIcon =()=> {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <g clip-path="url(#clip0_730_815)">
                                        <path d="M20.9946 21V20.9992H20.9999V13.2974C20.9999 9.52966 20.1888 6.62729 15.784 6.62729C13.6665 6.62729 12.2455 7.78929 11.6654 8.89091H11.6041V6.97904H7.42773V20.9992H11.7765V14.0569C11.7765 12.229 12.123 10.4615 14.3866 10.4615C16.617 10.4615 16.6503 12.5475 16.6503 14.1742V21H20.9946Z" fill="#F47523" />
                                        <path d="M0.34668 6.97986H4.70068V21H0.34668V6.97986Z" fill="#F47523" />
                                        <path d="M2.52175 0C1.12963 0 0 1.12963 0 2.52175C0 3.91387 1.12963 5.06712 2.52175 5.06712C3.91387 5.06712 5.0435 3.91387 5.0435 2.52175C5.04262 1.12963 3.913 0 2.52175 0V0Z" fill="#F47523" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_730_815">
                                            <rect width="21" height="21" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
    )
}

export const LinkIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M10 6.5C10 7.05228 9.55228 7.5 9 7.5C8.44772 7.5 8 7.05228 8 6.5C8 5.94772 8.44772 5.5 9 5.5C9.55228 5.5 10 5.94772 10 6.5Z"
          stroke-width="1.25"
          stroke-linecap="round"
        />
        <path
          d="M14 6.5C14 7.05228 13.5523 7.5 13 7.5C12.4477 7.5 12 7.05228 12 6.5C12 5.94772 12.4477 5.5 13 5.5C13.5523 5.5 14 5.94772 14 6.5Z"
          stroke-width="1.25"
          stroke-linecap="round"
        />
        <path
          d="M10 18.5C10 19.0523 9.55228 19.5 9 19.5C8.44772 19.5 8 19.0523 8 18.5C8 17.9477 8.44772 17.5 9 17.5C9.55228 17.5 10 17.9477 10 18.5Z"
          stroke-width="1.25"
          stroke-linecap="round"
        />
        <path
          d="M14 18.5C14 19.0523 13.5523 19.5 13 19.5C12.4477 19.5 12 19.0523 12 18.5C12 17.9477 12.4477 17.5 13 17.5C13.5523 17.5 14 17.9477 14 18.5Z"
          stroke-width="1.25"
          stroke-linecap="round"
        />
        <path
          d="M10 12.5C10 13.0523 9.55228 13.5 9 13.5C8.44772 13.5 8 13.0523 8 12.5C8 11.9477 8.44772 11.5 9 11.5C9.55228 11.5 10 11.9477 10 12.5Z"
          stroke-width="1.25"
          stroke-linecap="round"
        />
        <path
          d="M14 12.5C14 13.0523 13.5523 13.5 13 13.5C12.4477 13.5 12 13.0523 12 12.5C12 11.9477 12.4477 11.5 13 11.5C13.5523 11.5 14 11.9477 14 12.5Z"
          stroke-width="1.25"
          stroke-linecap="round"
        />
        <path
          d="M10 9.5C10 10.0523 9.55228 10.5 9 10.5C8.44772 10.5 8 10.0523 8 9.5C8 8.94772 8.44772 8.5 9 8.5C9.55228 8.5 10 8.94772 10 9.5Z"
          stroke-width="1.25"
          stroke-linecap="round"
        />
        <path
          d="M14 9.5C14 10.0523 13.5523 10.5 13 10.5C12.4477 10.5 12 10.0523 12 9.5C12 8.94772 12.4477 8.5 13 8.5C13.5523 8.5 14 8.94772 14 9.5Z"
          stroke-width ="1.25"
          stroke-linecap="round"
        />
        <path
          d="M10 15.5C10 16.0523 9.55228 16.5 9 16.5C8.44772 16.5 8 16.0523 8 15.5C8 14.9477 8.44772 14.5 9 14.5C9.55228 14.5 10 14.9477 10 15.5Z"
          stroke-width="1.25"
          stroke-linecap="round"
        />
        <path
          d="M14 15.5C14 16.0523 13.5523 16.5 13 16.5C12.4477 16.5 12 16.0523 12 15.5C12 14.9477 12.4477 14.5 13 14.5C13.5523 14.5 14 14.9477 14 15.5Z"
          stroke-width="1.25"
          stroke-linecap="round"
        />
      </svg>
    )
  }

  export const SmsIcon = () => {
    return (
        <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none" xmlns="http://www.w3.org/2000/svg">

            <path opacity="0.5" d="M13.0867 21.3877L13.7321 21.7697L13.0867 21.3877ZM13.6288 20.4718L12.9833 20.0898L13.6288 20.4718ZM10.3712 20.4718L9.72579 20.8539H9.72579L10.3712 20.4718ZM10.9133 21.3877L11.5587 21.0057L10.9133 21.3877ZM13.5 2.75C13.9142 2.75 14.25 2.41421 14.25 2C14.25 1.58579 13.9142 1.25 13.5 1.25V2.75ZM22.75 10.5C22.75 10.0858 22.4142 9.75 22 9.75C21.5858 9.75 21.25 10.0858 21.25 10.5H22.75ZM2.3806 15.9134L3.07351 15.6264V15.6264L2.3806 15.9134ZM7.78958 18.9915L7.77666 19.7413L7.78958 18.9915ZM5.08658 18.6194L4.79957 19.3123H4.79957L5.08658 18.6194ZM21.6194 15.9134L22.3123 16.2004V16.2004L21.6194 15.9134ZM16.2104 18.9915L16.1975 18.2416L16.2104 18.9915ZM18.9134 18.6194L19.2004 19.3123H19.2004L18.9134 18.6194ZM4.38751 2.7368L3.99563 2.09732V2.09732L4.38751 2.7368ZM2.7368 4.38751L2.09732 3.99563H2.09732L2.7368 4.38751ZM9.40279 19.2098L9.77986 18.5615L9.77986 18.5615L9.40279 19.2098ZM13.7321 21.7697L14.2742 20.8539L12.9833 20.0898L12.4412 21.0057L13.7321 21.7697ZM9.72579 20.8539L10.2679 21.7697L11.5587 21.0057L11.0166 20.0898L9.72579 20.8539ZM12.4412 21.0057C12.2485 21.3313 11.7515 21.3313 11.5587 21.0057L10.2679 21.7697C11.0415 23.0767 12.9585 23.0767 13.7321 21.7697L12.4412 21.0057ZM10.5 2.75H13.5V1.25H10.5V2.75ZM21.25 10.5V11.5H22.75V10.5H21.25ZM2.75 11.5V10.5H1.25V11.5H2.75ZM1.25 11.5C1.25 12.6546 1.24959 13.5581 1.29931 14.2868C1.3495 15.0223 1.45323 15.6344 1.68769 16.2004L3.07351 15.6264C2.92737 15.2736 2.84081 14.8438 2.79584 14.1847C2.75041 13.5189 2.75 12.6751 2.75 11.5H1.25ZM7.8025 18.2416C6.54706 18.2199 5.88923 18.1401 5.37359 17.9265L4.79957 19.3123C5.60454 19.6457 6.52138 19.7197 7.77666 19.7413L7.8025 18.2416ZM1.68769 16.2004C2.27128 17.6093 3.39066 18.7287 4.79957 19.3123L5.3736 17.9265C4.33223 17.4951 3.50486 16.6678 3.07351 15.6264L1.68769 16.2004ZM21.25 11.5C21.25 12.6751 21.2496 13.5189 21.2042 14.1847C21.1592 14.8438 21.0726 15.2736 20.9265 15.6264L22.3123 16.2004C22.5468 15.6344 22.6505 15.0223 22.7007 14.2868C22.7504 13.5581 22.75 12.6546 22.75 11.5H21.25ZM16.2233 19.7413C17.4786 19.7197 18.3955 19.6457 19.2004 19.3123L18.6264 17.9265C18.1108 18.1401 17.4529 18.2199 16.1975 18.2416L16.2233 19.7413ZM20.9265 15.6264C20.4951 16.6678 19.6678 17.4951 18.6264 17.9265L19.2004 19.3123C20.6093 18.7287 21.7287 17.6093 22.3123 16.2004L20.9265 15.6264ZM10.5 1.25C8.87781 1.25 7.6085 1.24921 6.59611 1.34547C5.57256 1.44279 4.73445 1.64457 3.99563 2.09732L4.77938 3.37628C5.24291 3.09223 5.82434 2.92561 6.73809 2.83873C7.663 2.75079 8.84876 2.75 10.5 2.75V1.25ZM2.75 10.5C2.75 8.84876 2.75079 7.663 2.83873 6.73809C2.92561 5.82434 3.09223 5.24291 3.37628 4.77938L2.09732 3.99563C1.64457 4.73445 1.44279 5.57256 1.34547 6.59611C1.24921 7.6085 1.25 8.87781 1.25 10.5H2.75ZM3.99563 2.09732C3.22194 2.57144 2.57144 3.22194 2.09732 3.99563L3.37628 4.77938C3.72672 4.20752 4.20752 3.72672 4.77938 3.37628L3.99563 2.09732ZM11.0166 20.0898C10.8136 19.7468 10.6354 19.4441 10.4621 19.2063C10.2795 18.9559 10.0702 18.7304 9.77986 18.5615L9.02572 19.8582C9.07313 19.8857 9.13772 19.936 9.24985 20.0898C9.37122 20.2564 9.50835 20.4865 9.72579 20.8539L11.0166 20.0898ZM7.77666 19.7413C8.21575 19.7489 8.49387 19.7545 8.70588 19.7779C8.90399 19.7999 8.98078 19.832 9.02572 19.8582L9.77986 18.5615C9.4871 18.3912 9.18246 18.3215 8.87097 18.287C8.57339 18.2541 8.21375 18.2487 7.8025 18.2416L7.77666 19.7413ZM14.2742 20.8539C14.4916 20.4865 14.6287 20.2564 14.7501 20.0898C14.8622 19.936 14.9268 19.8857 14.9742 19.8582L14.2201 18.5615C13.9298 18.7304 13.7204 18.9559 13.5379 19.2063C13.3646 19.4441 13.1864 19.7468 12.9833 20.0898L14.2742 20.8539ZM16.1975 18.2416C15.7862 18.2487 15.4266 18.2541 15.129 18.287C14.8175 18.3215 14.5129 18.3912 14.2201 18.5615L14.9742 19.8582C15.0192 19.832 15.096 19.7999 15.2941 19.7779C15.5061 19.7545 15.7842 19.7489 16.2233 19.7413L16.1975 18.2416Z" fill="#1C274C"/>
            <circle cx="19" cy="5" r="3" stroke="#1C274C" stroke-width="1.5"/>
        </svg>
    )
}

export const BusinessCategoryIcon = () => {
    return (
        <svg width="800px" height="800px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
            <g fill-rule="evenodd" clip-rule="evenodd" stroke="none" stroke-width="1">
                <path fill="#ffff" d="M1468.235 113v99.388l-112.94 112.941v-99.388H112.94v1468.235h1242.353v-438.211l112.941-112.941v664.094H0V113h1468.235ZM421.271 1163.353c96-9.035 154.729 108.423 190.87 197.647 28.235 68.894 38.4 92.612 72.283 96 33.882 3.388 89.223-58.73 112.94-101.647 16.53-26.51 51.42-34.6 77.93-18.07 26.51 16.529 34.6 51.42 18.07 77.929-9.035 16.94-92.611 160.376-205.552 160.376h-9.036c-70.023-4.517-121.976-48.564-169.411-166.023-47.436-117.46-77.93-127.624-77.93-127.624a484.518 484.518 0 0 0-97.13 225.883c-6.549 31.187-37.14 51.16-68.329 44.611-31.187-6.55-51.16-37.141-44.611-68.33 20.33-94.87 79.059-310.587 199.906-320.752Zm256.376-485.647v112.941H338.824V677.706h338.823ZM903.53 451.824v112.94H338.824v-112.94h564.705Z" />
                <path fill="white" d="m1903.059 468.765-225.883-225.883a56.47 56.47 0 0 0-80.188 0L919.341 920.53a56.476 56.476 0 0 0-15.813 39.53v282.353h282.354a56.47 56.47 0 0 0 39.53-16.941l677.647-677.647c21.523-21.959 21.523-57.101 0-79.06Zm-740.894 660.706H1016.47V983.776l451.764-451.764 145.694 145.694-451.764 451.765Zm531.953-531.953-145.694-145.694 89.223-89.224 145.694 145.694-89.223 89.224Z" />
            </g>
        </svg>
    )
}